import { Degrees } from '@core/blocks/edu-flow/components/Page/types';

export const isUnderGraduate = (degree: string) => degree !== Degrees.MASTERS && degree !== Degrees.DOCTORATE;
